// AdminGuard: redirects non-admin users to the inbox.
// Must be placed inside AuthGuard (token already verified).
// Shows nothing while agent info is still loading to avoid a flash redirect.

import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import type { ReactNode } from 'react';
import { INBOX_PATH } from '../lib/routeConfig';

export function AdminGuard({ children }: { children: ReactNode }) {
  const { isAuthenticated, agent, loading } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (loading || !agent) return null; // wait for agent info to load
  if (agent.role !== 'admin') return <Navigate to={INBOX_PATH} replace />;
  return <>{children}</>;
}

export function AdminOrSupervisorGuard({ children }: { children: ReactNode }) {
  const { isAuthenticated, agent, loading } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (loading || !agent) return null;
  if (agent.role !== 'admin' && agent.role !== 'supervisor') return <Navigate to={INBOX_PATH} replace />;
  return <>{children}</>;
}
